import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { loan, submissionDefaults } from '../../data/loan';
import { DetailGroup, DetailRow, SummaryCard } from './SummaryCard';
export function FannieSubmissionCards() {
  return <SummaryCard title="Submission Summary" icon={FileTextIcon} data-id="element-62" data-mp="2i278nwpetqcf">
      <div className="grid gap-6 sm:grid-cols-2 sm:gap-8" data-id="element-63" data-mp="2d3vxnindp9sm">
        <DetailGroup label="Loan" data-id="element-64" data-mp="2d6ifqc7wb7p3">
          <DetailRow label="Borrower" value={loan.borrower} data-id="element-65" data-mp="1pebcqu7o02gp" />
          <DetailRow label="Loan Number" value={loan.loanNumber} data-id="element-66" data-mp="1pgxjwsqn8fye" />
          <DetailRow label="Transaction Type" value={loan.transactionType} data-id="element-67" data-mp="1kh1qtojhi8xm" />
        </DetailGroup>
        <DetailGroup label="Submission" data-id="element-68" data-mp="1ygauxpuf1cl8">
          <DetailRow label="Submission Type" value={submissionDefaults.submissionType} data-id="element-69" data-mp="1yd6k49mg3ill" />
          <DetailRow label="Institution" value={submissionDefaults.institution} data-id="element-70" data-mp="1ug0pqfeg6q7f" />
          <DetailRow label="Lender" value={submissionDefaults.lender} muted data-id="element-71" data-mp="39t3kqv3nbqyn" />
        </DetailGroup>
      </div>
    </SummaryCard>;
}